import { plainText } from '../../../../../../modules/validators';
import { trimSpaces } from '../../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';

export enum UDIFieldKey {
    OEC_ATTENDEE_ID = 'attendeeId',
    ATTENDEE_EMAIL = 'attendeeEmail',
    PROVIDER = 'provider',
    PARTICIPANT_ID = 'uniqueDialInCode',
    CONFERENCE_ID = 'conferenceId',
    USER_ID = 'userId',
    AUDIO_BRIDGE_NAME = 'audioBridgeName'
}

export const FORM_CONFIG = {
    [UDIFieldKey.OEC_ATTENDEE_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.attendeeId', defaultMessage: 'OE Central Attendee ID', description: 'Label text' },
        defaultValue: '',
    },
    [UDIFieldKey.ATTENDEE_EMAIL]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.attendeeEmail', defaultMessage: 'Attendee Email', description: 'Label text' },
        defaultValue: '',
    },
    [UDIFieldKey.PROVIDER]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.provider', defaultMessage: 'Provider', description: 'Label text' },
        defaultValue: '',
    },
    [UDIFieldKey.PARTICIPANT_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.participantId', defaultMessage: 'Participant ID', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpaces]
    },
    [UDIFieldKey.CONFERENCE_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.conferenceId', defaultMessage: 'Conference ID', description: 'Label text' },
        defaultValue: '',
    },
    [UDIFieldKey.USER_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.attendeeCode', defaultMessage: 'User ID', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpaces]
    },
    [UDIFieldKey.AUDIO_BRIDGE_NAME]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueDialInCode.audioBridgeName', defaultMessage: 'Audio Bridge Name', description: 'Label text' },
        defaultValue: '',
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);